import React from 'react'
import styled from 'styled-components'
import InputMask from 'react-text-mask'
import { inputStyle } from './Input'

const StyledInput = styled(InputMask)`
    ${inputStyle}
    height: 33px;
`

export const TimeInput = ({value, onChange, ...rest}) => {
    
    const handleChange = (e) => {
        if (onChange) {
            onChange(e.target.value)
        }
    }
    
    return (
        <StyledInput 
            mask={[/\d/,/\d/,':',/\d/,/\d/]}
            onChange={handleChange}
            {...rest}
        />
    )}